import styled from "styled-components";
import { Fab } from "@material-ui/core";
import { green } from "@material-ui/core/colors";
import FormSimpleSelect from "@src/Components/Common/FormFields/FormSimpleSelect/FormSimpleSelect";

export const STFormSimpleSelect = styled(FormSimpleSelect).attrs({
  classes: { root: "root" },
})`
  && {
    .root {
      min-width: 150px;
    }
  }
`;

export const STFab = styled(Fab)`
  && {
    transform: scale(0.8);
  }
`;

export const STFabGreen = styled(STFab)`
  margin: 0;
  background-color: ${green[500]};
  color: #fafafa;
  :hover {
    background-color: ${green[700]};
  }
`;
